(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-top"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wilderness-80-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '.w80-popup';

    const safelyRead = (storage, key) => {
      try {
        return storage.getItem(key);
      } catch (error) {
        return null;
      }
    };

    const safelyWrite = (storage, key, value) => {
      try {
        storage.setItem(key, value);
      } catch (error) {
        // The popup still works when browser storage is unavailable.
      }
    };

    const initialisePopup = (root) => {
      if (!root || root.dataset.initialised === 'true') return;
      root.dataset.initialised = 'true';

      const panel = root.querySelector('.w80-popup__panel');
      const closeButton = root.querySelector('.w80-popup__close');
      const backdrop = root.querySelector('.w80-popup__backdrop');
      const isEditor = root.dataset.designMode === 'true';
      const isEnabled = root.dataset.enabled === 'true';
      const hasImage = root.dataset.hasImage === 'true';
      const frequency = root.dataset.frequency;
      const storageKey = `w80-popup:${root.dataset.sectionId}`;
      let previousFocus = null;
      let timer = null;

      if (!panel || !closeButton || !backdrop) return;

      const frequencyMilliseconds = {
        daily: 24 * 60 * 60 * 1000,
        weekly: 7 * 24 * 60 * 60 * 1000
      };

      const shouldOpen = () => {
        if (isEditor) return true;
        if (!isEnabled || !hasImage) return false;
        if (frequency === 'always') return true;

        if (frequency === 'session') {
          return safelyRead(window.sessionStorage, storageKey) !== 'seen';
        }

        const storedValue = safelyRead(window.localStorage, storageKey);
        if (!storedValue) return true;
        if (frequency === 'once') return false;

        const lastShown = Number(storedValue);
        const duration = frequencyMilliseconds[frequency];
        return !lastShown || !duration || Date.now() - lastShown >= duration;
      };

      const markAsShown = () => {
        if (isEditor || frequency === 'always') return;

        if (frequency === 'session') {
          safelyWrite(window.sessionStorage, storageKey, 'seen');
          return;
        }

        safelyWrite(window.localStorage, storageKey, String(Date.now()));
      };

      const openPopup = () => {
        previousFocus = document.activeElement;
        root.dataset.open = 'true';
        root.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('w80-popup-open');
        markAsShown();
        window.requestAnimationFrame(() => closeButton.focus());
      };

      const closePopup = () => {
        window.clearTimeout(timer);
        root.dataset.open = 'false';
        root.setAttribute('aria-hidden', 'true');

        if (!document.querySelector(`${rootSelector}[data-open='true']`)) {
          document.documentElement.classList.remove('w80-popup-open');
        }

        if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus();
        }
      };

      const trapFocus = (event) => {
        if (event.key !== 'Tab' || root.dataset.open !== 'true') return;

        const focusable = Array.from(
          panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
        ).filter((element) => !element.hasAttribute('hidden'));

        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };

      closeButton.addEventListener('click', closePopup);
      backdrop.addEventListener('click', () => {
        if (root.dataset.closeOnBackdrop === 'true') closePopup();
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePopup();
        trapFocus(event);
      });

      root.addEventListener('w80:open', openPopup);
      root.addEventListener('w80:close', closePopup);

      if (shouldOpen()) {
        const delay = isEditor ? 100 : Number(root.dataset.delay) || 0;
        timer = window.setTimeout(openPopup, delay);
      }
    };

    const initialiseAll = (scope = document) => {
      if (scope.matches && scope.matches(rootSelector)) initialisePopup(scope);
      scope.querySelectorAll(rootSelector).forEach(initialisePopup);
    };

    initialiseAll();

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const root = event.target.matches(rootSelector) ? event.target : event.target.querySelector(rootSelector);
      if (root) root.dispatchEvent(new CustomEvent('w80:open'));
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      const root = event.target.matches(rootSelector) ? event.target : event.target.querySelector(rootSelector);
      if (root) root.dispatchEvent(new CustomEvent('w80:close'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
